"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
const react_1 = __importStar(require("react"));
const Feature_elements_1 = require("./Feature.elements");
const play_button_svg_1 = __importDefault(require("@components/icons/landing/play-button.svg"));
const unfold_svg_1 = __importDefault(require("@components/icons/landing/unfold.svg"));
const classnames_1 = __importDefault(require("classnames"));
const Landing_1 = require("@app/routes/Landing");
// @ts-ignore
const Feature = ({ icon, title, text, href, slug, openVideo, className, signUpRequired, onlyRu, onlyPatient, onUnfoldClick, }) => {
    let isUserAuth = 'True';
    const link = signUpRequired
        ? // @ts-ignore
            isUserAuth === "True"
                ? href
                : "/registration"
        : href;
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const onPlayClick = () => {
        if (onlyRu && language !== "ru")
            return;
        openVideo(title, href, `https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/demo-videos/${language}/${slug}.mp4`);
    };
    let isTherapist = 'True';
    return (react_1.default.createElement(Feature_elements_1.FeatureWrap, { className: className },
        react_1.default.createElement("div", { className: "landing-feature-line frst" },
            icon,
            react_1.default.createElement("span", { className: (0, classnames_1.default)({ "landing-feature-title-absolute": !text }, "landing-feature-title") }, title)),
        react_1.default.createElement("div", { className: "landing-feature-line scnd" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("landing-feature-play", {
                    "landing-feature-play-disabled": typeof openVideo !== "function",
                }), onClick: onPlayClick },
                react_1.default.createElement(play_button_svg_1.default, null)),
            text && react_1.default.createElement("span", { className: "landing-feature-text" }, text)),
        onlyPatient &&
            // @ts-ignore
            isTherapist === "True" ? (react_1.default.createElement("div", { className: "landing-feature-unfold", onClick: onUnfoldClick },
            react_1.default.createElement(unfold_svg_1.default, null))) : (react_1.default.createElement("a", { href: link },
            react_1.default.createElement(unfold_svg_1.default, null)))));
};
exports.Feature = Feature;
